'use strict';

var Model = require('js/lib/model');
var COMMON_SCHEMA = require('js/commonSchema');
var Api = require('js/api');
var config = require('js/config');
const formatCommunityModel = require('js/lib/formatCommunityModel');

/**
 * Community
 * @exports Community
 * @constructor
 * @alias module:models/community
 * https://github.com/HealthUnlocked/Aurora-API/blob/master/docs/groups-endpoint/about-endpoint.md
 */
var Community = Model.extend({
  idAttribute: 'groupId',
  schema: {
    type: 'object',
    properties: {
      description: COMMON_SCHEMA.GROUP_DESCRIPTION,
      formattedDescription: COMMON_SCHEMA.GROUP_DESCRIPTION,
      website: COMMON_SCHEMA.URI,
      supportBoxBody: COMMON_SCHEMA.SUPPORT_BODY,
      supportBoxHeading: COMMON_SCHEMA.SUPPORT_HEADING,
      supportLink: COMMON_SCHEMA.SUPPORT_URI,
      contactNumber: COMMON_SCHEMA.PHONE,
      youtubePage: COMMON_SCHEMA.YOUTUBE_PAGE_URI,
      facebookPage: COMMON_SCHEMA.FACEBOOK_PAGE_URI,

      // those fields are not actual fields, they are used for validation
      instagramPage: COMMON_SCHEMA.INSTAGRAM_PAGE_URI, // field : instagramUsername
      twitterPage: COMMON_SCHEMA.TWITTER_PAGE_URI, // field: twitterHandle
    }
  },
  aboutUrl: config.build.apiPath + '/api/communities/about',
  joinUrl: config.build.apiPath + '/api/user-group-subscriptions',
  url: config.build.apiPath + '/api/communities'
});

/**
 * Parse api response
 */
Community.prototype.parse = function(resp) {
  const group = resp.groups ? resp.groups[0] : resp;
  const cachedData = this.getCachedData('groups', group.groupId);
  return formatCommunityModel(group, cachedData ? cachedData.attributes : null);
};

/**
 * Return group code for this community (api inconsistently sends groupCode or subDomain)
 * @returns String
 */
Community.prototype.getGroupCode = function() {
  return this.get('groupCode') || this.get('subDomain');
};

/**
 * Fetch community data by given subdomain
 */
Community.prototype.fetchOne = function(groupCode) {
  return this.desc('subDomain', groupCode).fetch();
};

Community.prototype.join = function(groupId, userId) {
  return Api.post(this.joinUrl, {
    data: {
      groupId: groupId,
      userId: userId
    }
  });
  // return this.desc('GroupId', groupId).desc('UserId', userId).save();
};

Community.prototype.leave = function(groupId, userId) {
  var url = app.router.router.toFragment(Community.prototype.joinUrl, {
    'groupId': groupId,
    'userId': userId
  });

  return Api.delete(url);
};

Community.prototype.updateAbout = function() {
  return Api.put(Community.prototype.aboutUrl, {
    data: this.attributes
  });
};

Community.prototype.resetAbout = function() {
  var url = app.router.router.toFragment(Community.prototype.aboutUrl, {
    'groupCode': this.attributes.groupCode || this.description.groupCode
  });

  return Api.delete(url);
};

/**
 * Upload banner image to api
 */
Community.prototype.uploadBannerImage = function(imageData) {
  return Api.post(this.url + '/banner', {
    data: {
      GroupId: this.get('id'),
      GroupCode: this.get('groupCode'),
      GroupBanner: imageData
    }
  }).then(function(response) {
    return response.groupBanner.uncroppedImageUrl;
  });
};

/**
 * Crop banner image on api
 */
Community.prototype.cropBannerImage = function(x, y, width, height) {
  return Api.put(this.url + '/banner', {
    data: {
      GroupId: this.get('id'),
      GroupCode: this.get('groupCode'),
      X: x,
      Y: y,
      Width: width,
      Height: height
    }
  }).then(function(response) {
    return response.groupBanner.bannerUrl;
  });
};

/**
 * Crop avatar image on api
 */
Community.prototype.cropAvatarImage = function(x, y, width) {
  return Api.put(this.url + '/logo', {
    data: {
      GroupId: this.get('id'),
      GroupCode: this.get('groupCode'),
      X: x,
      Y: y,
      Width: width
    }
  }).then(function(response) {
    return response.groupLogo;
  });
};

/**
 * Update welcome message
 */
Community.prototype.updateWelcome = function(groupCode, enabled, welcomeMessage) {
  return Api.put(Community.prototype.url + '/welcome', {
    data: {
      'groupCode': groupCode,
      'IsWelcomeMessageEnabled': enabled,
      'WelcomeMessage': welcomeMessage
    }
  });
};

/**
 * Crop campaign image link on api and save it
 */
Community.prototype.cropCampaignImage = function(x, y, width, height, link, filename) {
  return Api.put(this.url + '/campaign', {
    data: {
      GroupId: this.get('id'),
      GroupCode: this.get('groupCode'),
      CampaignLink: link,
      filename: filename,
      X: x,
      Y: y,
      Width: width,
      Height: height,
    },
  }).then(function(response) {
    return response.groupCampaign.imageUrl;
  });
};

module.exports = Community;



// WEBPACK FOOTER //
// ./app/assets/js/models/community.js